import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { fetchViewCourseDetailsRequest } from "./store/view-course.action";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHeaderCell,
  TextOverflow,
  TableHead,
  Accordion,
  AccordionItem,
  Select,
  SelectOption,
  CardContent,
  Card,
  Search,
  Button,
  StatusBadge,
  Divider,
  AvatarIcon,
  CalendarIcon,
  ClockIcon,
  ArrowLeftIcon,
  OpenInNewIcon,
  Control,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@forge/common";
import Header from "../common/components/header/header";
import LeftPanel from "../common/components/left-panel/left-panel";
import "./view-course.scss";
import { ITable, ITableHeader } from "./model/index";
import { VIEW_COURSE_CONSTANTS } from "./utils/constants";
import { CREATE_COURSE_CONSTANTS } from "../create-course/utils/constants"
import { AppState } from "../../../../common/store/combinedReducer";
import { getWMKSDetails, clearWMKSDetails } from "../../../store/action";
import config from "../../../../common/authentication/config";
import WarningPopup from "./popup/warning";
import { hideModel, showModel, showToast } from "../store/model/model.action";
import VmName from "./vm-name";

const ViewCourse = () => {
  const { courseDefintionID } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const viewCourseDefinitionDetails = useSelector(
    (
      state: AppState
    ): ReturnType<
      (typeof state.viewCourseReducer)["viewCourseDefinitionDetails"]
    > => state.viewCourseReducer.viewCourseDefinitionDetails
  );
  const loading = useSelector(
    (state: AppState) => state.viewCourseReducer.loading
  );
  const [showLeftPanel, setShowLeftPanel] = React.useState<boolean>(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [openVm, setOpenVm] = React.useState(false);
  const [vmDetails, setVmDetails] = React.useState<any>({});
  let openedTabs: any;
  const wmksDetails = useSelector((state: AppState) => {
    return state.reducer.wmksDetails;
  });
  const wmksStatus = useSelector((state: AppState) => {
    return state.reducer.wmksStatus;
  });
  useEffect(() => {
    setShowLoader(loading);
  }, [loading]);

  useEffect(() => {
    if (wmksStatus === 409 && wmksDetails?.message) {
      dispatch(
        showToast({
          type: "error",
          title: "",
          subtitle: wmksDetails.message,
        })
      );
      setOpenVm(false);
      dispatch(clearWMKSDetails());
      return;
    }
    if (
      wmksDetails?.host !== null &&
      wmksDetails?.host !== undefined &&
      openVm &&
      wmksStatus === 200
    ) {
      if (vmDetails?.vmName) {
        window
          .open(
            `/dashboard/vmware/${config?.SITE_ID}/${vmDetails?.vmName}`,
            "",
            "noopener"
          )
          ?.focus();
        localStorage.setItem(
          vmDetails?.vmName,
          JSON.stringify({
            name: vmDetails?.vmName,
            id: vmDetails?.vmId,
            orgId: config?.ACADEMY_TENANT_ID,
            tenantId: config?.ACADEMY_TENANT_ID,
            siteId: config?.SITE_ID,
            orgName: viewCourseDefinitionDetails?.courseOrgName,
            wmksData: wmksDetails,
            isVmWindow: true,
          })
        );
        // openedTabs = Number(localStorage.getItem("openedTabs") || "0");
        // openedTabs += 1;
        // localStorage.setItem("openedTabs", openedTabs?.toString());
        setOpenVm(false);
      }
    }
  }, [wmksDetails, wmksStatus]);

  const getMksToken = async (data: any) => {
    openedTabs = Number(localStorage.getItem("openedTabs") || "0");
    if (openedTabs >= 10) {
      dispatch(
        showToast({
          type: "error",
          title: "",
          subtitle: CREATE_COURSE_CONSTANTS.MAX_VMS_OPENED,
        })
      );
    } else {
      dispatch(
        showModel({
          childTemplate: () => (
            <WarningPopup
              title={"!Warning!"}
              description={
                "Install antivirus software on the available nodes to ensure the optimum cyber security and protection."
              }
              btnText={VIEW_COURSE_CONSTANTS.CANCEL}
              btnText1={VIEW_COURSE_CONSTANTS.CONFIRM}
              onCancel={() => dispatch(hideModel())}
              onTrigger={() => {
                setVmDetails({
                  vmId: `vm-${data?.vcdVmID}`,
                  vmName: data?.vmName,
                });
                dispatch(hideModel());
                dispatch(
                  getWMKSDetails({
                    id: `vm-${data?.vcdVmID}`,
                    orgId: config?.ACADEMY_ORGID,
                    orgName: viewCourseDefinitionDetails?.courseOrgName,
                    accessToken: localStorage.getItem("access_token"),
                    siteId: config?.SITE_ID,
                    tenantId: config?.ACADEMY_TENANT_ID,
                  })
                );
                setOpenVm(true);
              }}
            />
          ),
        })
      );
    }
  };

  useEffect(() => {
    if (courseDefintionID) {
      dispatch(fetchViewCourseDetailsRequest(courseDefintionID));
    }
  }, [dispatch, courseDefintionID]);

  const data = Array.isArray(viewCourseDefinitionDetails?.vmDetails)
    ? viewCourseDefinitionDetails.vmDetails
    : [];
  const [filterType, setFilterType] = useState("Name");
  const [searchValue, setSearchValue] = useState("");
  const [sortField, setSortField] = useState<string | undefined>(undefined);
  const [sortDirection, setSortDirection] = useState<
    "asc" | "desc" | undefined
  >(undefined);
  const [isExpandAllActive, setIsExpandAllActive] = useState(true);

  const toggleSort = (field: string) => {
    if (sortField !== field) {
      setSortField(field);
      setSortDirection("asc");
      return;
    }
    if (sortDirection === "asc") {
      setSortDirection("desc");
    } else if (sortDirection === "desc") {
      setSortField(undefined);
      setSortDirection(undefined);
    } else {
      setSortDirection("asc");
    }
  };

  const getSearchPlaceholder = () => {
    if (filterType === "Name") {
      return VIEW_COURSE_CONSTANTS.SearchByName;
    } else if (filterType === "OS_type") {
      return VIEW_COURSE_CONSTANTS.SearchByOsType;
    }
    return VIEW_COURSE_CONSTANTS.SearchByName;
  };
  const filteredData = data.filter((item: ITable) => {
    if (!searchValue) return true;
    const keyword = searchValue.toLowerCase();
    if (filterType === "Name") {
      return (item.vmName ?? item.Name ?? "")
        .toString()
        .toLowerCase()
        .includes(keyword);
    } else if (filterType === "OS_type") {
      return (item.osType ?? item.OS_type ?? "")
        .toString()
        .toLowerCase()
        .includes(keyword);
    }
    return true;
  });

  const sortedData = React.useMemo(() => {
    if (!sortField || !sortDirection) return filteredData;
    const arr = [...filteredData];
    if (sortField === "Name") {
      arr.sort((a: ITable, b: ITable) => {
        const aName = (a.vmName ?? a.Name ?? "").toString().toLowerCase();
        const bName = (b.vmName ?? b.Name ?? "").toString().toLowerCase();
        if (aName < bName) return sortDirection === "asc" ? -1 : 1;
        if (aName > bName) return sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }
    return arr;
  }, [filteredData, sortField, sortDirection]);

  const tableHeaders: ITableHeader[] = [
    { id: "Name", name: "NAME", width: "155px" },
    { id: "OS_type", name: "OS TYPE", width: "112px" },
    { id: "os_version", name: "OS VERSION", width: "123px" },
    { id: "ram", name: "RAM", width: "81px" },
    { id: "cpu", name: "CPU", width: "76px" },
    { id: "ipaddress", name: "IP ADDRESS", width: "121px" },
    { id: "storage", name: "STORAGE", width: "103px" },
    { id: "VM_Pausable", name: "VM PAUSABLE", width: "145px" },
  ];

  const handleClickHam = () => {
    setShowLeftPanel((prev) => !prev);
  };
  const handleExpandAll = () => {
    const accordion = document.querySelector('[data-testid="accordion"]');
    if (!accordion) return;
    const collapsedTriggers: HTMLElement[] = Array.from(
      accordion.querySelectorAll('[aria-expanded="false"]')
    ).filter(
      (el: Element) =>
        !el.closest(".select-course") &&
        el.getAttribute("role") !== "combobox" &&
        !(el as HTMLElement).closest(".forge-select")
    ) as HTMLElement[];

    if (collapsedTriggers.length > 0) {
      collapsedTriggers.forEach((t) => t.click());
      setIsExpandAllActive(true);
      return;
    }

    const items = accordion.querySelectorAll(".AccordionItem");
    items.forEach((item) => {
      let header =
        (item.querySelector(
          ".AccordionItem__header, button, [data-accordion-trigger]"
        ) as HTMLElement) || null;
      if (!header) return;
      if (
        header.closest(".select-course") ||
        header.getAttribute("role") === "combobox"
      )
        return;
      const expandedAttr = header.getAttribute("aria-expanded");
      const isOpen = item.classList.contains("open") || expandedAttr === "true";
      if (!isOpen) header.click();
    });
    setIsExpandAllActive(true);
  };
  const handleCollapseAll = () => {
    const accordion = document.querySelector('[data-testid="accordion"]');
    if (!accordion) return;
    const expandedTriggers: HTMLElement[] = Array.from(
      accordion.querySelectorAll('[aria-expanded="true"]')
    ).filter(
      (el: Element) =>
        !el.closest(".select-course") &&
        el.getAttribute("role") !== "combobox" &&
        !(el as HTMLElement).closest(".forge-select")
    ) as HTMLElement[];

    if (expandedTriggers.length > 0) {
      expandedTriggers.forEach((t) => t.click());
      setIsExpandAllActive(false);
      return;
    }

    const items = accordion.querySelectorAll(".AccordionItem");
    items.forEach((item) => {
      let header =
        (item.querySelector(
          ".AccordionItem__header, button, [data-accordion-trigger]"
        ) as HTMLElement) || null;
      if (!header) return;
      if (
        header.closest(".select-course") ||
        header.getAttribute("role") === "combobox"
      )
        return;
      const expandedAttr = header.getAttribute("aria-expanded");
      const isOpen = item.classList.contains("open") || expandedAttr === "true";
      if (isOpen) header.click();
    });
    setIsExpandAllActive(false);
  };

  return (
    <>
      {showLoader && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90">
          <div className="flex flex-row items-center justify-center">
            <span className="inline-block w-9 h-9 border-4 border-blue-400 border-solid rounded-full border-t-transparent animate-spin"></span>
            <span className="ml-4 text-white font-16 font-normal">Loading</span>
          </div>
        </div>
      )}
      <div className="h-full flex">
        <div className="h-full">
          <LeftPanel showLeftPanel={showLeftPanel} />
        </div>
        <div className="w-full text-white p-4">
          <div className="mt-3">
            <Header handleClickHam={handleClickHam} />
          </div>
          <div className="application-dark custom-app-dark overflow-y-auto flex flex-col p-2.5">
            <div className="header-bar mb-4">
              <label className="font-style font-bold !text-base xl-low:!text-base xl-mid:!text-[23px] xl-high:!text-[26px]">
                {VIEW_COURSE_CONSTANTS.viewCourseTemplate}
              </label>
              <Link
                to={VIEW_COURSE_CONSTANTS.BACK_LINK_URL}
                className="flex items-center gap-2 text-[#64C3FF] hover:!text-[#64C3FF] no-underline text-center font-bold leading-[20px] tracking-[0.5px] !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px]"
              >
                <ArrowLeftIcon /> {VIEW_COURSE_CONSTANTS.backToLibrary}
              </Link>
            </div>
            <div className="px-5 py-0">
              <div className="header-bar mx-auto w-[70vw] min-w-full max-w-4xl dark:bg-container-dark course-header-bar">
                <label className="font-style !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px]">
                  {viewCourseDefinitionDetails?.courseOrgName}
                </label>
                <div className="display flex justify-end mt-4">
                  <Button
                    className={`!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[20px] mr-4 !border-none !text-white border-none text-white ${isExpandAllActive ? "!bg-[#103F61]" : "!bg-[#404040]"
                      }`}
                    id="expand-all"
                    size="regular"
                    variant="secondary"
                    iconPosition="right"
                    onClick={handleExpandAll}
                  >
                    {VIEW_COURSE_CONSTANTS.expandAll}
                  </Button>
                  <Button
                    className={`!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[20px] mr-4 !border-none !text-white border-none text-white ${!isExpandAllActive ? "!bg-[#103F61]" : "!bg-[#404040]"
                      }`}
                    id="collapse-all"
                    size="regular"
                    variant="secondary"
                    iconPosition="right"
                    onClick={handleCollapseAll}
                  >
                    {VIEW_COURSE_CONSTANTS.collapseAll}
                  </Button>
                  <Button
                    className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[20px]"
                    id="edit-course-view"
                    data-testid="edit-course-view"
                    size="regular"
                    variant="primary"
                    disabled={viewCourseDefinitionDetails?.courseStage !== 3}
                    onClick={() =>
                      navigate(`/academy/editCourse/${courseDefintionID}`)
                    }
                  >
                    {VIEW_COURSE_CONSTANTS.edit}
                  </Button>
                </div>
              </div>
              <div className="px-2.5 py-0">
                <Divider orientation="horizontal" />
              </div>
              <Accordion
                className="mx-auto w-[70vw] min-w-full max-w-4xl dark:bg-container-dark rounded-b-md"
                id="accordion"
                multi={true}
                data-testid="accordion"
                defaultOpenIndex={[0, 1]}
              >
                <AccordionItem
                  id="generalDetails"
                  data-testid="generalDetails"
                  title={VIEW_COURSE_CONSTANTS.generalDetails}
                  className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] fontweight-unset"
                >
                  <div className="flex gap-10 bg-[#303030] pt-[15px] pr-[15px] pb-[50px] pl-[15px] mr-[45px]">
                    <div className="flex flex-col gap-2 w-1/2">
                      <div className="flex mb-2 xl-high:!mb-4">
                        <div className="w-1/4 xl-high:!w-1/5 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark">
                          {VIEW_COURSE_CONSTANTS.courseName}
                        </div>
                        <div className="w-1/2 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse whitespace-pre-line break-words max-w-full">
                          {viewCourseDefinitionDetails?.courseOrgName}
                        </div>
                      </div>
                      <div className="flex mb-2 xl-high:!mb-4">
                        <div className="w-1/4 xl-high:!w-1/5 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark">
                          {VIEW_COURSE_CONSTANTS.description}
                        </div>
                        <div className="w-1/2 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse whitespace-pre-line break-words max-w-full">
                          {viewCourseDefinitionDetails?.courseDescription ||
                            "--"}
                        </div>
                      </div>
                      <div className="flex">
                        <div className="w-1/4 xl-high:!w-1/5 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark">
                          {VIEW_COURSE_CONSTANTS.status}
                        </div>
                        <div className="w-1/2 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse">
                          <StatusBadge
                            color={
                              [0, 1, 2, 3].includes(
                                viewCourseDefinitionDetails?.courseStage
                              )
                                ? "orange"
                                : viewCourseDefinitionDetails?.courseStage === 4
                                  ? "green"
                                  : viewCourseDefinitionDetails?.courseStage === 5
                                    ? "gray"
                                    : viewCourseDefinitionDetails?.courseStage === 8
                                      ? "red"
                                      : undefined
                            }
                            className="text-[0.5rem] items-center mr-2"
                          />
                          {viewCourseDefinitionDetails?.courseStage === 0 ||
                            viewCourseDefinitionDetails?.courseStage === 1 ||
                            viewCourseDefinitionDetails?.courseStage === 2
                            ? "InProgress"
                            : viewCourseDefinitionDetails?.courseStage === 3
                              ? "Draft"
                              : viewCourseDefinitionDetails?.courseStage === 4
                                ? "Published"
                                : viewCourseDefinitionDetails?.courseStage === 5
                                  ? "Expired"
                                  : viewCourseDefinitionDetails?.courseStage === 8
                                    ? "Failed"
                                    : ""}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col gap-2 w-1/2">
                      <div className="flex gap-6 xl-high:!gap-10 xl-mid:!gap-8 mb-2 xl-high:!mb-4">
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark ml-4 xl-mid:!ml-5 xl-high:!ml-6">
                          {VIEW_COURSE_CONSTANTS.lastModifiedBy}
                        </div>
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse">
                          <AvatarIcon className="mr-2" />{" "}
                          {viewCourseDefinitionDetails?.lastModifiedBy}
                        </div>
                      </div>
                      <div className="flex gap-6 xl-high:!gap-10  xl-mid:!gap-8 mb-2 xl-high:!mb-4">
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark">
                          {VIEW_COURSE_CONSTANTS.lastModifiedDate}
                        </div>
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse">
                          <CalendarIcon className="mr-2" />{" "}
                          {viewCourseDefinitionDetails?.lastModifiedDate
                            ? moment(
                              viewCourseDefinitionDetails.lastModifiedDate
                            ).format("DD MMM YYYY")
                            : ""}
                        </div>
                      </div>
                      <div className="flex gap-6 xl-high:!gap-10  xl-mid:!gap-8 mb-2 xl-high:!mb-4 ml-20">
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark ml-3 xl-mid:!ml-10 xl-high:!ml-20">
                          {VIEW_COURSE_CONSTANTS.time}
                        </div>
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse">
                          <ClockIcon className="mr-2" />{" "}
                          {viewCourseDefinitionDetails?.lastModifiedDate
                            ? moment(
                              viewCourseDefinitionDetails.lastModifiedDate
                            ).format("hh:mm:ss A")
                            : ""}
                        </div>
                      </div>
                      <div className="flex gap-6 xl-high:!gap-9 ml-1  xl-mid:!gap-8 xl-high:!ml-10 xl-mid:!ml-6">
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark ml-16 xl-mid:!ml-27 xl-high:!ml-20">
                          {VIEW_COURSE_CONSTANTS.duration}
                        </div>
                        <div className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-secondary-inverse">
                          <CalendarIcon className="mr-2" />{" "}
                          {viewCourseDefinitionDetails?.courseDuration}{" "}
                          {VIEW_COURSE_CONSTANTS.days}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItem>
                <AccordionItem
                  id="vappDetails"
                  data-testid="vappDetails"
                  className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] fontweight-unset"
                  title={VIEW_COURSE_CONSTANTS.vappDetails}
                >
                  <div className="vapp-details-header p-[10px] xl-high:!p-[14px]">
                    <div>
                      <span className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-color-tertiary-dark mr-2">
                        {VIEW_COURSE_CONSTANTS.associatedVappTemplate}
                      </span>{" "}
                      <span className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-white">
                        {viewCourseDefinitionDetails?.vAppTemplateName}
                      </span>
                    </div>
                  </div>
                  <div className="">
                    <Card className="rounded-none !border-none flex flex-col h-auto shadow-none">
                      <div className="flex pl-5 pr-5 justify-between items-center">
                        <div className="flex items-center gap-3 relative">
                          <div className="w-[250px] xl-high:!w-[320px]">
                            <Search
                              className="view-course-search-bar !border-none w-[250px] xl-high:!w-[320px] bg-transparent border-none outline-none text-white px-2 rounded !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[20px]"
                              aria-label="Search"
                              debounce={100}
                              id="search"
                              data-testid="search"
                              defaultValue={searchValue}
                              minCharacters={1}
                              onChange={(val: any) =>
                                setSearchValue(val?.target?.value)
                              }
                              placeholder={getSearchPlaceholder()}
                              size="regular"
                            />
                          </div>
                          <div className="w-[240px] pb-2 xl-high:!w-[320px]">
                            <Control className="select-course">
                              <Select
                                className="font-w-400 !border-none view-course-filter w-[370px] xl-high:!w-[320px] xl-high:!h-[43px] xl-high:!pt-[11px] !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[22px]"
                                height={5}
                                id="filter-select"
                                data-testid="filter-select"
                                placeholder="Name"
                                size="regular"
                                value={filterType}
                                defaultValue="Name"
                                onChange={(val: any) =>
                                  setFilterType(val?.target?.value ?? val)
                                }
                              >
                                <SelectOption
                                  label={
                                    VIEW_COURSE_CONSTANTS.templateNameFilter ||
                                    "Name"
                                  }
                                  value={"Name"}
                                />
                                <SelectOption
                                  label={
                                    VIEW_COURSE_CONSTANTS.osTypeFilter ||
                                    "OS TYPE"
                                  }
                                  value={"OS_type"}
                                />
                              </Select>
                            </Control>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px]">
                          {VIEW_COURSE_CONSTANTS.resultsRange(
                            filteredData.length > 0 ? 1 : 0,
                            filteredData.length,
                            data.length
                          )}{" "}
                          <span className="mr-2 ml-2">|</span>
                          {filterType === "Name"
                            ? "Filter Applied by Name"
                            : filterType === "OS_type"
                              ? "Filter Applied by OS Type"
                              : VIEW_COURSE_CONSTANTS.noFiltersApplied}
                        </div>
                      </div>
                      <CardContent
                        x="none"
                        y="none"
                        className="card-content-custom flex flex-col overflow-y-auto min-h-[calc(100vh-300px)] max-h-[calc(100vh-300px)]"
                      >
                        <Table fixedFirstColumn onCard>
                          <TableHead>
                            <TableRow>
                              {tableHeaders.map((header: ITableHeader) => {
                                const isSortable = header.id === "Name";
                                const active = sortField === header.id;
                                const indicator =
                                  active && sortDirection ? (
                                    <span className="ml-1 inline-block align-top pl-2 font-color-white relative -top-1">
                                      {sortDirection === "asc" ? (
                                        <ChevronUpIcon />
                                      ) : (
                                        <ChevronDownIcon />
                                      )}
                                    </span>
                                  ) : null;
                                return (
                                  <TableHeaderCell
                                    className={`!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] ${isSortable
                                      ? "cursor-pointer select-none"
                                      : ""
                                      }`}
                                    id={header.id}
                                    key={header.id}
                                    data-testid={header.name}
                                    style={
                                      header.width
                                        ? {
                                          width: header.width,
                                          minWidth: header.width,
                                          maxWidth: header.width,
                                        }
                                        : undefined
                                    }
                                    onClick={() => {
                                      if (isSortable) toggleSort(header.id);
                                    }}
                                  >
                                    <span className="flex items-center">
                                      {header.name}
                                      {indicator}
                                    </span>
                                  </TableHeaderCell>
                                );
                              })}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sortedData.length === 0 ? (
                              <TableRow>
                                <TableCell
                                  colSpan={tableHeaders.length}
                                  className="text-center !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] text-gray-400 py-8"
                                >
                                  No data found
                                </TableCell>
                              </TableRow>
                            ) : (
                              sortedData.map((data: ITable, i: number) => {
                                const _isSelected = false;
                                return (
                                  <TableRow
                                    id={`table-${i}`}
                                    data-testid={`table-${i}`}
                                    selected={_isSelected}
                                    key={i}
                                  >
                                    <VmName
                                      data={data}
                                      getMksToken={getMksToken}
                                    />
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-[7rem] truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.osType || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-[7rem] truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.osVersionName || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-xs truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.ram || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-xs truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.cpu || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-[7rem] truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.iPv4 || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-xs truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.storage || "--"}
                                      </TextOverflow>
                                    </TableCell>
                                    <TableCell className="!text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-xs truncate whitespace-nowrap">
                                      <TextOverflow>
                                        {data.isPausable === "true"
                                          ? "Yes"
                                          : data.isPausable === "false"
                                            ? "No"
                                            : "--"}
                                      </TextOverflow>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            )}
                          </TableBody>
                        </Table>
                      </CardContent>
                    </Card>
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCourse;
